import { render, staticRenderFns } from "./ServiceEvaluation.vue?vue&type=template&id=52c38e71&scoped=true"
import script from "./ServiceEvaluation.vue?vue&type=script&lang=js"
export * from "./ServiceEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ServiceEvaluation.vue?vue&type=style&index=0&id=52c38e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c38e71",
  null
  
)

export default component.exports